<section>
  <h3>Anschrift</h3>
  <!-- Anrede -->
  <form-row>
    <mat-form-field appearance="outline">
      <mat-label>Anrede</mat-label>
      <mat-select required [formControl]="formGroup.controls.salutation" [disabled]="disable">
        <mat-option *ngFor="let ele of salutations$ | async" [value]="ele.id">
          {{ ele.title }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.controls.salutation.hasError('required')">
        Anrede ist erforderlich
      </mat-error>
    </mat-form-field>
  </form-row>

  <!-- Vorname, Nachname der Person -->
  <form-row *ngIf="isPerson$ | async; else isCompany">
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Vorname</mat-label>
      <input
        [disabled]="disable"
        required
        matInput
        type="text"
        [formControl]="formGroup.controls.firstName" />
      <mat-error>Vorname ist erforderlich</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Nachname</mat-label>
      <input [disabled]="disable" required matInput type="text" [formControl]="formGroup.controls.lastName" />
      <mat-error>Nachname ist erforderlich</mat-error>
    </mat-form-field>
  </form-row>
  <!-- Firmenname + Zusatz des Unternehmens -->
  <ng-template #isCompany>
    <form-row>
      <mat-form-field appearance="outline" fxFlex>
        <mat-label>Firmenname 1</mat-label>
        <input
          [disabled]="disable"
          required
          matInput
          type="text"
          [formControl]="formGroup.controls.company"
          maxlength="40" />
        <mat-error>Firmenname 1 ist erforderlich</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" fxFlex>
        <mat-label>Firmenname 2</mat-label>
        <input [disabled]="disable" matInput type="text" [formControl]="formGroup.controls.companyAddition" />
      </mat-form-field>
    </form-row>
  </ng-template>

  <!-- Adresse -->
  <form-row>
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Straße</mat-label>
      <input [disabled]="disable" required matInput type="text" [formControl]="formGroup.controls.street" />
      <mat-error>Straße ist erforderlich</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Hausnummer</mat-label>
      <input
        [disabled]="disable"
        required
        matInput
        type="text"
        [formControl]="formGroup.controls.streetNo"
        maxlength="6" />
      <mat-error>Hausnummer ist erforderlich</mat-error>
    </mat-form-field>
  </form-row>
  <form-row>
    <mat-form-field appearance="outline">
      <mat-label>PLZ</mat-label>
      <input [disabled]="disable" required matInput type="text" [formControl]="formGroup.controls.zipCode" />
      <mat-error>PLZ ist erforderlich</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Ort</mat-label>
      <input [disabled]="disable" required matInput type="text" [formControl]="formGroup.controls.city" />
      <mat-error>Ort ist erforderlich</mat-error>
    </mat-form-field>
  </form-row>
</section>
